import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, ShieldCheck, CreditCard, Star } from 'lucide-react';
export function Hero() {
  const badges = [{
    icon: <FileText size={16} data-id="element-71" />,
    text: 'PDF descargable'
  }, {
    icon: <Zap size={16} data-id="element-72" />,
    text: 'Acceso inmediato'
  }];
  return <section className="relative pt-3 pb-8 px-4 md:pt-4 md:pb-12 max-w-[44rem] mx-auto text-center overflow-hidden" data-id="element-73">
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse at center, rgba(160,200,245,0.25) 0%, rgba(160,200,245,0.08) 40%, transparent 70%)'
    }} data-id="element-74" />
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} data-id="element-75">
        <span className="inline-block py-1 px-3 rounded-full bg-mint/10 text-mint font-semibold text-xs md:text-sm mb-3 tracking-wide uppercase" data-id="element-76">
          ✏️ Atención: Psicopedagogas y Docentes
        </span>

        <h1 className="md:text-5xl lg:text-6xl mb-4 font-[900] font-['Open_Sans',_sans-serif] text-white text-[28px] md:leading-[1.1] leading-tight" data-id="element-77">
          Dejá de pasar horas armando material de{' '}
          <span className="text-mint" data-id="element-78">lectoescritura</span>
        </h1>

        <div className="mb-4 flex justify-center" data-id="element-79">
          <img src="https://cdn.magicpatterns.com/uploads/bikmcLTmmACkuC8Kue9Dmk/e9b4453d-1447-4f9d-80d6-542ca16a86f8.png" alt="MegaPack de Lectoescritura - Plan PRO" className="w-full max-w-[460px] md:max-w-[560px] drop-shadow-2xl pl-[80px] pr-[80px]" data-id="element-80" />
        </div>

        <p className="md:text-2xl italic text-mint/80 mb-4 max-w-3xl mx-auto text-[18px] font-[800] font-[Avenir,_sans-serif]" data-id="element-81">
          "Listo para imprimir y usar. Sin buscar más. Sin improvisar. Sin
          sacrificar tus tardes."
        </p>

        <p className="text-white/60 max-w-2xl mx-auto mb-5 text-[15px] md:text-[16px]" data-id="element-82">
          MegaPack de Lectoescritura — Plan PRO: el sistema completo para
          psicopedagogas y docentes. Actividades, sesiones, informes,
          seguimiento y gestión profesional, listo para aplicar desde hoy.
        </p>

        {/* Rating bar */}
        <div className="inline-flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-surface border border-mint/15 rounded-full px-4 py-2 mb-5" data-id="element-83">
          <div className="flex items-center gap-1" data-id="element-84">
            {[...Array(5)].map((_, i) => <Star key={i} size={14} className="fill-mint text-mint" data-id="element-85" />)}
          </div>
          <span className="text-white/80 text-sm font-bold" data-id="element-86">4.9/5</span>
          <span className="text-white/40 text-sm" data-id="element-87">+850 profesionales</span>
          <span className="hidden md:inline text-mint text-sm font-bold" data-id="element-88">
            🔥 62 compraron hoy
          </span>
        </div>

        <div className="flex flex-wrap justify-center gap-3 mb-6 max-w-4xl mx-auto" data-id="element-89">
          {badges.map((badge, idx) => <div key={idx} className="flex items-center gap-1.5 bg-surface border border-mint/10 px-3 py-1.5 rounded-md text-sm text-white/80 font-medium shadow-sm" data-id="element-90">
              <span className="text-mint" data-id="element-91">{badge.icon}</span>
              {badge.text}
            </div>)}
        </div>

        <motion.a href="#oferta-pro" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="inline-block bg-mint hover:bg-mint/80 text-black font-bold text-lg md:text-xl py-4 px-8 md:px-12 rounded-xl shadow-lg shadow-mint/20 transition-colors" data-id="element-92">
          🚀 ¡SÍ! QUIERO MI MEGAPACK AHORA
        </motion.a>
      </motion.div>
    </section>;
}